import { Typography } from "@dm-4dev/ui";
import clsx from "clsx";
import { motion } from "framer-motion";
import { TicketPlusIcon } from "lucide-react";

export const MainHeader = () => {
  return (
    <motion.header
      className={clsx(
        "w-full",
        "flex",
        "items-center",
        "justify-start",
        "pl-32",
        "md:pl-44",
        "pr-4",
        "bg-primary",
        "py-1",
        "h-36",
        "md:h-52",
        "realtive",
        "bg-gradient-to-r",
        "text-white",
        "border-b-4",
        "border-accent"
      )}
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        className="absolute top-0 left-4 rounded-full bg-white px-7 py-5 -ml-14 md:top-4"
      >
        <img src="/logo-comu.png" alt="logo" className="ml-4 h-28 md:h-32 w-auto" />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="flex-1 hidden md:block"
      >
        <Typography variant="subheading" className="text-accent">
          {"Comunidad Católica El Salvador del Mundo"} <br />
        </Typography>
        <Typography variant="caption" className="text-muted">
          {"Unidos en fe y servicio a nuestra comunidad."}
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <Typography variant={"subheading"} className="flex gap-2 items-center md:text-white text-accent">
          <TicketPlusIcon size={38} />
          Inscripción
        </Typography>
      </motion.div>
    </motion.header>
  );
};
